import { useWakeLockNavigator } from './wake-lock-navigator.hook.js'
import { useWakeLockNoSleep } from './wake-lock-nosleep.hook.js'

const hasWakeLock = typeof navigator !== 'undefined' && 'wakeLock' in navigator

export const useWakeLock = hasWakeLock ? useWakeLockNavigator : useWakeLockNoSleep
